module.exports = "../fonts/airo-image.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/airo-image.svg
// module id = 417
// module chunks = 0